import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@mui/material';

import WarningIcon from 'shared/icons/Warning';
import styled from 'shared/utils/styled';

export const Description = styled('p')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontFamily: 'NeoSansStd',
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.primary.main,
  wordBreak: 'break-word',
}));

type DeleteChatMessageConfirmationDialogContentProps = {
  onClose: () => void;
  onDelete: () => void;
};

const DeleteChatMessageConfirmationDialogContent = ({
  onClose,
  onDelete,
}: DeleteChatMessageConfirmationDialogContentProps) => {
  const { t } = useTranslation();

  const handleClickDeleteButton = () => {
    onDelete();
    onClose();
  };

  return (
    <Stack alignItems="center" spacing={3}>
      <WarningIcon
        sx={{
          fontSize: '4rem',
          color: (theme) => theme.palette.warning.main,
        }}
      />
      <Description>{t('MessageDeleteConfirmation')}</Description>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="flex-end"
        spacing={2}
        width="100%"
      >
        <Button onClick={onClose}>Peruuta</Button>
        <Button color="success" onClick={handleClickDeleteButton}>
          Poista
        </Button>
      </Stack>
    </Stack>
  );
};

export default DeleteChatMessageConfirmationDialogContent;
